// In order to make a component available for consumers of this package,
// it MUST be exported within this file.

// Imports below this line
import { Eye, Close, AudioButton } from "./icons";
import { CreateMenu, DropdownItem } from "./components/create/CreateMenu";
import "./styles/main.scss";

// Exports below this line
// Icons
export const Icon = {
  Eye,
  Close,
  AudioButton,
};

// Components
export const HeaderCreateMenu = { CreateMenu, DropdownItem };

export { PreviewButton } from "./components/create/PreviewButton";
export { NameForm } from "./components/create/NameForm";

export { DSModal } from "./components/global/DSModal";
export { EaselButton } from "./components/global/EaselButton";
export { DSEaselButton } from "./components/global/DSEaselButton";
export { ErrorAlert } from "./components/global/ErrorAlert";
export { MoreMenu } from "./components/global/MoreMenu";

export {
  PublishProvider,
  FormattedData,
  FormattedResource,
} from "./components/publish/PublishContext";
export { PublishModal } from "./components/publish/PublishModal";
export { usePublishModal } from "./components/publish/usePublishModal";
export { ExtraItem } from "./components/publish/Resources";

export { Audio } from "./components/audio/AudioPlayer";
export { MediaUploadModal } from "./components/upload/MediaUploadModal";

export { PremiumBuyerUpgradeModal } from "./components/premium/PremiumBuyerUpgradeModal";
export { PremiumSellerUpgradeModal } from "./components/premium/PremiumSellerUpgradeModal";

export { ContentViolationScreen } from "./components/contentViolation/ContentViolationScreen";
export { StudentContentViolationScreen } from "./components/contentViolation/StudentContentViolationScreen";
export { ContentViolationBanner } from "./components/contentViolation/ContentViolationBanner";
export { ContentViolationLabel } from "./components/contentViolation/ContentViolationLabel";
export { EaselStudentLogoutModal } from "./components/global/EaselStudentLogoutModal";

// helpers
export {
  colors,
  easelColors,
  easelFontFamily,
  getColorWithOpacity,
} from "./helpers/constants";

export { useFocus } from "./hooks";
